var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBF2C3",
    fillRule: "evenodd",
    d: "M6 3C3 3 .5 5.3.5 8.3V36c0 3 2.5 5.5 5.5 5.5h31c3 0 5.5-2.5 5.5-5.5V8.4C42.5 5.4 40 3 37 3H6Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#calendar_SVG_gradient)",
    d: "M1 8a5 5 0 0 1 5-5h31a5 5 0 0 1 5 5v7H1V8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M11.6 23.7V17h1v6.7H21V17h1v6.7h8.4V17h1v6.7h7.4v1h-7.4v7h7.4v1h-7.4V39h-1v-6.3H22V39h-1v-6.3h-8.4V39h-1v-6.3H4.2v-1h7.4v-7H4.2v-1h7.4Zm1 1v7H21v-7h-8.4Zm9.4 0v7h8.4v-7H22ZM11.5 0c.6 0 1 .4 1 1v2h18V1a1 1 0 1 1 2 0v2H37c3 0 5.5 2.4 5.5 5.4V15H.5V8.4C.5 5.4 3 3 6 3h4.5V1c0-.6.4-1 1-1Zm19 4v2a1 1 0 1 0 2 0V4H37c2.5 0 4.5 2 4.5 4.4V14h-40V8.4C1.5 6 3.5 4 6 4h4.5V6a1 1 0 1 0 2 0V4h18Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar_SVG_gradient",
    x1: 1,
    x2: 42.9,
    y1: 3,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CFDA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.25d66813074fc07c713c3057a4465a31.svg";
export { ForwardRef as ReactComponent };